import { CallIntelligenceService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { DemoInterceptorUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { serviceName } from '../../service';
import * as CallIntelTypes from '../../types';
import { BaseMockRouterContext } from './types';

export type CallIntelFollowupMockRouterContext = BaseMockRouterContext;

export const CallIntelFollowupMockRouter: FeatureMockRouter<CallIntelFollowupMockRouterContext> = {
  getRequestInterceptors: ({ interceptorIdPrefix, vertical, hasVoiceAiAccess }) => [
    {
      id: `${interceptorIdPrefix}-call-follow-ups`,
      interceptor: async (request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.ListFollowups,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.ListFollowupsIO['input'] = await request.clone().json();
        requestBody.isDemo = true;
        requestBody.demoMetadata = {
          ...requestBody.demoMetadata,
          vertical,
          features: {
            enableCallIntelligence: true,
            enableVoiceAi: hasVoiceAiAccess,
          },
        };

        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },

    {
      id: `${interceptorIdPrefix}-call-follow-ups-stats`,
      interceptor: async (request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.GetCallFollowupsStats,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.GetCallFollowupsStatsIO['input'] = await request.clone().json();
        requestBody.isDemo = true;

        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },
  ],
  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries([serviceName, 'ListFollowups']);
    queryClient.invalidateQueries([serviceName, 'GetCallFollowupsStats']);
  },
};
